import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";
import useUserStore from "../../utils/storeApp";
import { usePortalAuthentication } from "../../services/authorizationService";

const EulaAction = () => {
  const { userToken, SetSharedObject } = useUserStore((state) => ({
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const navigate = useNavigate();
  const [agreeBox, SetAgreeBox] = useState(false); //
  const [agreeBoxMsg, SetAgreeBoxMsg] = useState(false);
  const [errFlag, setErrFlag] = useState(false);
  const [processing, SetProcesing] = useState(false);
  const { logout } = usePortalAuthentication();

  useEffect(() => {
    SetAgreeBoxMsg(false);
  }, []);
  const submitEULA = async (flag) => {
    SetAgreeBoxMsg(false);
    if (flag === "decline") {
      logout();
      return;
    }
    if (!agreeBox) {
      SetAgreeBoxMsg(true);
      return;
    }
    SetProcesing(true);
    let call = "/admin/EULAFunction";
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res && res.status === "SUCCESS") {
      console.log(res);
      if (res.data.page === "ChangePassword") {
        navigate("/password-change-preRegistration");
      } else if (res.data.page === "dashboard") {
        navigate("/dashboard");
      } else if (res.data.page === "SSO") {
        navigate("/experian-sso");
      }
      SetProcesing(false);
    } else if (res.status === "SERVERERROR") {
      setErrFlag(true);
      SetProcesing(false);
    }
  };
  return (
    <>
      <label className="license-container">
        <input
          type="checkbox"
          className="form-control spacer-margin5"
          value={agreeBox}
          onChange={(el) => {
            SetAgreeBox(el.target.checked);
            if (el.target.checked) SetAgreeBoxMsg(false);
          }}
        />
        By submitting this EULA (End User License Agreement), I have read and
        accept the License Agreement.
      </label>
      {errFlag ? (
        <div className="ml-2">
          <div className="alert alert-danger" role="alert">
            System encounted an error. Please try again. If the problem
            persists, please contact your administrator.
          </div>
        </div>
      ) : null}
      {agreeBoxMsg ? (
        <div className="alert alert-danger">
          Don't forget to check the box if you agree.
        </div>
      ) : null}

      <div className="eula-button-container">
        <div className="button-accept">
          <button
            type="button"
            className="btn btn-success"
            value="I Agree"
            onClick={(e) => submitEULA("submit")}
          >
            I Agree
          </button>
        </div>

        <div className="button-decline">
          <button
            type="submit"
            className="btn btn-outline-secondary"
            value="I Decline"
            onClick={(e) => submitEULA("decline")}
          >
            I Decline
          </button>
        </div>
      </div>
      {processing ? <div className="loading"></div> : null}
    </>
  );
};

export default EulaAction;
